import React, { Component } from "react";
import { FormGroup, Input, Button, Container, FormFeedback } from "reactstrap";
import { Link,useHistory  } from "react-router-dom";
import { SvgAssets } from "../../assets/icons/iconSvg";
import c from "../../constants/Colors";
import Spinner from "../reusable/Loader";
import { RegistrarSugerencia } from "../../store/sagas/authApi";
import localStorageCustom from "../../utilitarios/localStorage";
import { notificacion } from "../../utilitarios/util";

function Step1({ dadComponent }) {
  let { textSugerencia, error, validation, longMax, long ,errorsGeneral} = dadComponent.state;
  return (
    <div>
      <div className="card card_container">
        <SvgAssets
          icon="curve-bottom"
          className="curve-top mobile"
          fill="#1B52B2"
        />
        {error ? validation : null}
        <p className="paragraph-2 light azul mb-1">
          Por favor ingrese su sugerencia.
        </p>
        <p className="paragraph-3 light" style={{ color: c.grisMedio }}>
          (Máx. 500 caracteres)
        </p>
        <FormGroup className="mt-3 mx-auto w-100" style={{ maxWidth: 440 }}>
          <Input
            type="textarea"
            placeholder="Sugerencia"
            rows="7"
            maxlength={longMax}
            value={textSugerencia}
            onChange={(textSugerencia) =>
              dadComponent.setText(textSugerencia.target.value)
            }
          />
          <p
            className="paragraph-3 light text-right mt-2 mb-0"
            style={{ color: c.grisMedio }}
          >
            {long}/ {longMax - long}
          </p>
          {
              errorsGeneral ? <FormFeedback className="pl-0">{errorsGeneral}</FormFeedback> : null
          }
        </FormGroup>
        <div className="text-center mt-3 mobile">
          <button
            type="button"
            className={`btn-block${!error ? " disabled" : ""}`}
            style={{ backgroundColor: c.verdeClaro }}
            onClick={() => dadComponent.postSugerencia()}
            disabled={!error}
          >
            ENVIAR
          </button>          
        </div>
      </div>
      <div className="text-center mt-5 desktop">
        <button
          type="button"
          className={`btn-block${!error ? " disabled" : ""}`}
          style={{ backgroundColor: c.verdeClaro }}
          onClick={() => dadComponent.postSugerencia()}
          disabled={!error}
        >
          ENVIAR 
        </button>
      </div>
    </div>
  );
}

function Step2({ dadComponent, auth }) {
  const { dealer } = dadComponent.state;
  const history = useHistory();
  console.log('history',history)
  return (
    <div>
      <div className="card card_container">
        <div className="empty sugerencia" style={{ maxWidth: 560 }}>
          <SvgAssets icon="icon-happy" fill={c.azulClaro} />
          <h6 className="paragraph-1 mb-2" style={{ color: c.azulClaro }}>
            Muchas gracias
          </h6>
          <p className="paragraph-2 text-center">
            Hola {dealer.razsocialSocial}, muchas gracias por registrar tu sugerencia,
            esto nos ayudará a mejorar y podremos brindarte una mejor
            experiencia.
          </p>
          <div className="text-center mt-5 mobile">
              <button
                className="btn-block"
                style={{ backgroundColor: c.verdeClaro }}
                onClick={() => history.push('/dashboard')}
              >
                ENTENDIDO
              </button>
          </div>
        </div>
      </div>
      <div
        className="text-center mt-5 desktop"
        style={{ justifyContent: "center" }}
      >
          <button
            className="btn-block"
            style={{ backgroundColor: c.verdeClaro }}
            onClick={() => history.push('/dashboard')}
          >
            ENTENDIDO
          </button>
      </div>
    </div>
  );
}

export class Sugerencias extends Component {
  constructor(props) {
    super(props);
    //let storageGeneral = localStorageCustom.prototype.getUsuario();
    this.state = {
      step: 0,
      loading: true,
      dealer: {},
      linea: {},
      asociado: {},
      longMax: 500,
      long: 0,
      textSugerencia: "",
      botonEnviar: true,
      showAlert: false,
      alertTitulo: "",
      alertMensaje: "",
      error: false,
      errorsGeneral: null,
    };
  }

  nextStep() {
    this.setState({ step: this.state.step + 1 });
  }

  backStep() {
    this.setState({ step: this.state.step - 1 });
  }
  setText = (value) => {
    this.setState({
      textSugerencia: value,
      long: value.length,
      botonEnviar: !(value.trim().length > 0),
      error: value.trim().length > 0,
    });
  };

  validation = () => {
    return (
      <div>
        <p className="paragraph-2 light azul mb-1">
          Por favor ingrese su sugerencia.
        </p>
        <p className="paragraph-3 light" style={{ color: c.grisMedio }}>
          (Máx. 500 caracteres)
        </p>
      </div>
    );
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    let result = localStorageCustom.prototype.getUsuario();
    this.setState({
      loading: false,
      dealer: result.dealer,
      linea: result.linea,
      asociado: result.asociado,
      showAlert: false,
      alertTitulo: "",
      alertMensaje: "",
    });
  }

  renderStep() {
    const auth = this.context;
    switch (this.state.step) {
      case 0:
        return <Step1 dadComponent={this} />;
      case 1:
        return <Step2 dadComponent={this} />;
      default:
        return <Step1 dadComponent={this} />;
    }
  }
  postSugerencia = async () => {
    // logEvents(analytics.Linea_de_negocio.Linea_de_negocio_click_seleccion_repuestos
    //   , analytics.Linea_de_negocio.whoIs()
    //   , storageGeneral.linea.nombreLinea);
    let strMensaje = this.state.textSugerencia;

    if (strMensaje === "" || strMensaje == null || strMensaje.length > 500)
      this.setState({ error: true });
    let data = {
      correoElectronico: this.state.dealer.correoElectronico,
      codcliente: this.state.dealer.codcliente,
      linea: this.state.linea.linea,
      mensaje: this.state.textSugerencia,
      //codigoPerfil: this.state.linea.codigoPerfil,
    };
    this.setState({ loading: true });
    RegistrarSugerencia(data)
      .then((result) => {
        this.setState({ loading: false });
        if (result.mo.type == "success") {
          this.setState({ email: data.correoElectronico }, () => {
            this.nextStep();
          });
          // this.props.navigation.navigate('AuthMensaje', { email: this.state.email });
        } else {
          this.setState({
            loading: false,
            errorsGeneral: result.mo.listMessage.join(", "),
          });
        }
      })
      .catch((error) => {
        error.message =
          error.message == undefined || error.message == null
            ? error.description
            : error.message;
        this.setState({ loading: false }, async () => {
          // await this.notificacion("Solicitar Acceso", error.message ?? null);
          notificacion("Sugerencias", error.message ?? null);
        });
      });
  };

  render() {
    const { loading, step } = this.state;
    return (
      <div>
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Sugerencias</h1>
          </Container>
          <SvgAssets icon="curve-top" className="curve-bottom" fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li>
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li>Ayuda</li>
              <li>Sugerencias</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          {step == 0 ? (
            <h6 className="title white">
              <a onClick={this.backStep} className="back">
                <SvgAssets icon="icon-arrow-left" fill={"#fff"} />
              </a>
              Sugerencias
            </h6>
          ) : null}
          {this.renderStep()}
        </Container>
      </div>
    );
  }
}
